import { Box, CardMedia, Grid, InputAdornment, Typography, useTheme } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { MFTextField } from '../../lib/formik';
import { Formik, FormikHandlers, FormikHelpers, useFormik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  getAddressData,
  getAddressFields,
  getApplicantName,
  preventSpecialCharacters,
  saveForLater,
  _updatedAddresses,
  checkForCorrespondenceAddress,
  removeSingleQuote,
  getEmailPhonePersonRelationType,
  sendRoleBasedStatus,
  capitalize,
} from '../../utils/utilityFunctions';
import { ApplicantAddressType, ApplicationProps, DataMaster, DataMasters, dataTypeMasters } from '../../redux-store/types/api-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { contactDetailsSchema } from '../../utils/schema';
import {
  APPLICATION_TYPE,
  USER_ROLES,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatusMasters,
  ENABLE_EMAIL_OTP,
  ContactRelations,
  personLDetailsStatusMasters,
} from '../../utils/constant';
import { CountryCodesDropDown } from '../commonComponents';
// import { getNationalityList } from '../../redux-store/actions';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import MFSelectField from '../../lib/formik/SelectField';
import { InfoIconFilled } from '../../assets/SvgIcons';
import { getDataMasters } from '../../redux-store/actions/onBoarding';
import { showError } from '../../redux-store/actions/auth';

type ContactDetailsProps = {
  phoneNumberoffice: string;
  phoneNumberResidence: string;
  email: string;
  mobile: string;
  countryNameAndCode: string;
  countryCode: string;
  address: {
    nationality?: string | null;
    status?: string | null;
    permanent?: Partial<ApplicantAddressType>;
    correspondence?: Partial<ApplicantAddressType>;
    overseas?: Partial<ApplicantAddressType>;
    [key: string]: Partial<ApplicantAddressType> | string | null | undefined;
  };
  kraMobileNumber: string;
  emailPersonRelation: string;
  emailPersonRelationType: string;
  phonePersonRelation: string;
  phonePersonRelationType: string;
  alternateNumber: string;
  alternateNumberCountryNameAndCode: string;
  alternateNumberCountryCode: string;
  whatsappNumber: string;
  whatsappNumberCountryNameAndCode: string;
  whatsappNumberCountryCode: string;
};

export type Values = {
  hasPOA: boolean;
  applicants: ContactDetailsProps[];
  saveType: string;
  countryDropdown: string[];
  [key: string]: string | boolean | ContactDetailsProps[] | string[];
};

const initialValues: Values = {
  hasPOA: false,
  applicants: [
    {
      phoneNumberoffice: '',
      phoneNumberResidence: '',
      email: '',
      mobile: '',
      countryNameAndCode: 'India: +91',
      countryCode: '+91',
      address: {
        nationality: null,
        status: null,
        permanent: getAddressFields('permanent'),
        correspondence: getAddressFields('correspondence'),
        overseas: getAddressFields('overseas'),
      },
      kraMobileNumber: '',
      emailPersonRelation: '',
      emailPersonRelationType: '',
      phonePersonRelation: '',
      phonePersonRelationType: '',
      alternateNumber: '',
      alternateNumberCountryNameAndCode: 'India: +91',
      alternateNumberCountryCode: '+91',
      whatsappNumber: '',
      whatsappNumberCountryNameAndCode: 'India: +91',
      whatsappNumberCountryCode: '+91',
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

export const Address = ({
  addressType = '',
  index,
  // nationalitiesMdmsResponse,
  fetchedFromKRACheck,
  dataMasters,
  dataMasterLoading,
}: {
  addressType: string;
  index: number;
  // nationalitiesMdmsResponse: mdmsCountriesList[];
  fetchedFromKRACheck: boolean | null;
  dataMasters: DataMaster;
  dataMasterLoading?: boolean;
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  // const isFieldDisabled =
  //   (['overseas'].includes(addressType) &&
  //     [USER_ROLES.POAAPPROVER].includes(role)) ||
  //   (!['permanent', 'correspondence'].includes(addressType) && fetchedFromKRACheck) ||
  //   false;
  const isFieldDisabled = (fetchedFromKRACheck && `${addressType ?? ''}`.toLowerCase() !== 'overseas') || false;
  const { values, setFieldValue } = useFormikContext() as { values: Values; setFieldValue: any };
  const { application } = useSelector((store: RootStateType) => store.application);

  const {
    COUNTRY = [],
    STATE = [],
    CITY = [],
  } = dataMasters || {};

  const isDropDown = ['overseas'].includes(addressType) || application?.applicants[index].kycMethod == 'osv';
  const isOverseas = `${addressType ?? ''}`.toLowerCase() === 'overseas';

  return (
    <>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address1`}
          label={`Address Line 1*`}
          placeholder="Enter Address Line 1"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address2`}
          label={`Address Line 2`}
          placeholder="Enter Address Line 2"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.address3`}
          label={`Address Line 3`}
          placeholder="Enter Address Line 3"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.pincode`}
          label={`PIN Code*`}
          placeholder="Enter Pincode"
          disabled={isFieldDisabled}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        {isDropDown
          ? <SearchableSelect
            name={`applicants.${index}.address.${addressType}.city`}
            label="City*"
            items={CITY?.map((val: any) => ({
              key: val?.description,
              value: val?.description,
            }))}
            searchFieldPlaceholder={'Search City'}
            disabled={isFieldDisabled || dataMasterLoading || isOverseas}
            loading={dataMasterLoading}
          />
          : <MFTextField
            name={`applicants.${index}.address.${addressType}.city`}
            label={`City*`}
            placeholder="Enter City"
            disabled={isFieldDisabled}
          />}
      </Grid>
      {(isOverseas || `${(values.applicants[index]?.address?.[addressType] as Partial<ApplicantAddressType>)?.city ?? ''}`.toLowerCase() === 'others') && (
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.address.${addressType}.otherCity`}
            label={`Enter City*`}
            placeholder="Enter Other City"
            disabled={isFieldDisabled}
          />
        </Grid>
      )}
      <Grid item xs={12} lg={6}>
        {isDropDown
          ? <SearchableSelect
            name={`applicants.${index}.address.${addressType}.state`}
            label="State*"
            items={STATE?.map((val: any) => ({
              key: val?.description,
              value: val?.description,
            }))}
            searchFieldPlaceholder={'Search State'}
            disabled={isFieldDisabled || dataMasterLoading || isOverseas}
            loading={dataMasterLoading}
          />
          : <MFTextField
            name={`applicants.${index}.address.${addressType}.state`}
            label={`State*`}
            placeholder="Enter State"
            disabled={isFieldDisabled}
          />}
      </Grid>
      {(isOverseas || `${(values.applicants[index]?.address?.[addressType] as Partial<ApplicantAddressType>)?.state ?? ''}`.toLowerCase() === 'others') && (
        <Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.address.${addressType}.otherState`}
            label={`Enter State*`}
            placeholder="Enter Other State"
            disabled={isFieldDisabled}
          />
        </Grid>
      )}
      <Grid item xs={12} lg={6}>
        {/* {!nationalitiesMdmsResponse && (
          <MFTextField
            name={`applicants.${index}.address.${addressType}.country`}
            label={`Country *`}
            placeholder="Enter Country"
            disabled={isFieldDisabled}
          />
        )} */}
        {/* {nationalitiesMdmsResponse && ( */}
        <SearchableSelect
          name={`applicants.${index}.address.${addressType}.country`}
          label="Country*"
          items={COUNTRY?.map((val: any) => ({
            key: val?.description,
            value: val?.description,
          }))}
          // disabled={isFieldDisabled}
          searchFieldPlaceholder={'Search Country'}
          disabled={isFieldDisabled || dataMasterLoading || addressType === 'permanent'}
          loading={dataMasterLoading}
          onChange={(e) => {
            const value = e.target.value;
            setFieldValue(`applicants.${index}.address.${addressType}.country`, value);
            // if (`${value ?? ''}`.toLowerCase() !== 'india') {
            //   setFieldValue(`applicants.${index}.address.${addressType}.permanentAddressSameAsCorresponding`, false);
            //   setFieldValue(`applicants.${index}.address.permanent`, getAddressFields('permanent'));
            // }
            if (addressType === 'correspondence' && `${value ?? ''}`.toLowerCase() !== 'india') {
              setFieldValue(`applicants.${index}.address.${addressType}.permanentAddressSameAsCorresponding`, false);
              setFieldValue(`applicants.${index}.address.permanent`, getAddressFields('permanent'));
            }
            // Auto-populate country code when overseas country is selected
            if (addressType === 'overseas' && value) {
              if (String(value).toLowerCase() !== 'others') {
                const matchedCountry = COUNTRY?.find(
                  (c: any) => c.description?.toLowerCase() === String(value).toLowerCase() || c.countryName?.toLowerCase() === String(value).toLowerCase()
                );
                if (matchedCountry?.countryCode) {
                  const countryLabel = `${matchedCountry.description || matchedCountry.countryName}: +${matchedCountry.countryCode}`;
                  setFieldValue(
                    `applicants.${index}.address.${addressType}.countryNameAndCode`,
                    countryLabel
                  );
                }
              }
            }
          }}
        // onChange={(e) => {
        //   setFieldValue(`applicants.${index}.address.${addressType}.country`, e.target.value);
        //   if (addressType === 'overseas') {
        //     const country = nationalitiesMdmsResponse.find((country) => country.name === e.target.value);
        //     setFieldValue(`applicants.${index}.address.${addressType}.countryNameAndCode`, `${country?.name}: ${country?.dial_code}`);
        //   }
        // }}
        />
        {/* )} */}
      </Grid>
      {addressType === 'overseas' && <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.address.${addressType}.mobile`}
          label="Overseas Mobile Number"
          placeholder="Enter Overseas Mobile Number"
          onKeyDown={(e) => {
            preventSpecialCharacters(e);
          }}
          // readOnly={values.hasPOA ? false : true}
          disabled={isFieldDisabled}
          startAdornment={
            <CountryCodesDropDown
              // ElementWidth={mobileElementWidth && mobileElementWidth}
              name={`applicants.${index}.address.${addressType}.countryNameAndCode`}
              value={values.applicants[index]?.address?.overseas?.countryNameAndCode ?? 'India: +91'}
              disabled={isFieldDisabled || (() => {
                  const selectedCountry = (values.applicants[index]?.address?.overseas?.country ?? '');
                  if (!selectedCountry || selectedCountry.toLowerCase() === 'others') return false;
                  const matchedCountry = COUNTRY?.find(
                    (c: any) => c.description?.toLowerCase() === selectedCountry.toLowerCase() || c.countryName?.toLowerCase() === selectedCountry.toLowerCase()
                  );
                  return !!(matchedCountry?.countryCode);
                })()}
              
            />
          }
        />
      </Grid>}
    </>
  );
};

const ApplicantDetails = ({
  values,
  handleChange,
  setValues,
  // mdmsCountriesList,
  application,
  isRMFieldDisabled,
  dataMasters,
  dataMasterLoading,
  isRekyc
}: {
  values: Values;
  handleChange: FormikHandlers['handleChange'];
  setValues: FormikHelpers<Values>['setValues'];
  // mdmsCountriesList: mdmsCountriesList[];
  application: ApplicationProps | null;
  isRMFieldDisabled?: boolean;
  dataMasters: DataMaster;
  dataMasterLoading: boolean;
  isRekyc?: boolean
}): JSX.Element => {
  const { path: currentPath } = useRouteMatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [mobileElementWidth, setMobileElementWidth] = useState(null);

  useEffect(() => {
    const mobileElement = document.getElementsByName('applicants.0.countryNameAndCode');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  const theme = useTheme()

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application");

  const {
    MOB_BELONGS_TO = [],
    MAIL_ID_BELONGS_TO = [],
  } = dataMasters || {};

  return (
    <React.Fragment>
      <Grid item xs={12}>
        {([USER_ROLES.RM].includes(role) && (application?.applicants[0]?.kycMethod !== 'osv')) && (
          <SubHeading
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              gap: '10px',
              backgroundColor: theme.palette.warning[50],
              color: theme.palette.warning[900],
            }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <InfoIconFilled width={24} height={24} background-color={theme.palette.warning[500]} />
            </Box>
            <Typography variant='body_400'>Data will be auto populated from the KYC validation method selected by investor (Digilocker/CKYC)</Typography>
          </SubHeading>
        )}
      </Grid>
      {values.applicants.map((applicant, index) => (
        <React.Fragment key={index}>
          <Grid item xs={12}>
            <SubHeading>Contact details of {getApplicantName(index + 1)} Applicant</SubHeading>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.email`}
              label="Email ID*"
              placeholder="Enter E-Mail ID"
              // readOnly={values.hasPOA ? false : true && ENABLE_EMAIL_OTP}
              // startAdornment={
              //   <InputAdornment position="start">
              //     <CardMedia component="img" alt="Email Icon" src="/images/email.svg" />
              //   </InputAdornment>
              // }
              disabled={([USER_ROLES.RM].includes(role) ? false : true) || isRekyc}
            // disabled={(isDiyInvestorOnboarding ? false : ((!application?.editable && USER_ROLES.INVESTOR !== role)) || (USER_ROLES.INVESTOR === role && index !== 0))}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFSelectField
              name={`applicants.${index}.emailPersonRelationType`}
              label="This Email ID belongs to?*"
              items={MAIL_ID_BELONGS_TO?.map((relation: dataTypeMasters) => ({
                key: relation?.description,
                value: relation?.description,
              }))}
              onChange={(e) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((_applicant, _index) => {
                    if (_index === index) {
                      return {
                        ..._applicant,
                        emailPersonRelationType: e.target.value,
                        emailPersonRelation: `${e.target.value ?? ''}`.toLowerCase() === 'others' ? '' : e.target.value,
                      };
                    }
                    return _applicant;
                  }) as ContactDetailsProps[],
                });
              }}
              disabled={dataMasterLoading}
              loading={dataMasterLoading}
            />
          </Grid>

          {values.applicants.map((applicant, idx: number) => {
            if (`${applicant.emailPersonRelationType ?? ''}`.toLowerCase() === 'others' && idx === index) {
              return (
                <Grid
                  item
                  xs={12}
                  lg={6}
                  key={idx}
                >
                  <MFTextField
                    name={`applicants.${index}.emailPersonRelation`}
                    label="Please Specify Relationship*"
                    placeholder={`Enter Relationship`}
                    disabled={dataMasterLoading}
                  />
                </Grid>
              );
            }
          })}

          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.mobile`}
              label="Mobile Number*"
              placeholder="Enter Mobile Number"
              onKeyDown={(e) => {
                preventSpecialCharacters(e);
              }}
              // readOnly={values.hasPOA ? false : true}
              startAdornment={
                <CountryCodesDropDown
                  ElementWidth={mobileElementWidth && mobileElementWidth}
                  name={`applicants.${index}.countryNameAndCode`}
                  value={values.applicants[index].countryNameAndCode}
                  // readOnly={values.hasPOA ? false : true}
                  // disabled={[USER_ROLES.INVESTOR].includes(role)}
                  // disabled={
                  //   isDiyInvestorOnboarding ? false :
                  //     ((!application?.editable && USER_ROLES.INVESTOR !== role) ||
                  //       (USER_ROLES.INVESTOR === role && index !== 0))
                  // }
                  // disabled={isRekyc}
                  disabled={([USER_ROLES.RM].includes(role) ? false : true) || isRekyc || ['Non-Individual', 'Individual'].includes(application?.applicants?.[index]?.status ?? '')}
                />
              }
              // disabled={[USER_ROLES.INVESTOR].includes(role)}
              // disabled={
              //   isDiyInvestorOnboarding ? false :
              //     ((!application?.editable && USER_ROLES.INVESTOR !== role) ||
              //       (USER_ROLES.INVESTOR === role && index !== 0))
              // }
              disabled={([USER_ROLES.RM].includes(role) ? false : true) || isRekyc}
            // disabled={isRekyc}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFSelectField
              name={`applicants.${index}.phonePersonRelationType`}
              label="This Mobile Number belongs to?*"
              items={MOB_BELONGS_TO?.map((relation: dataTypeMasters) => ({
                key: relation?.description,
                value: relation?.description,
              }))}
              onChange={(e) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((_applicant, _index) => {
                    if (_index === index) {
                      return {
                        ..._applicant,
                        phonePersonRelationType: e.target.value,
                        phonePersonRelation: `${e.target.value ?? ''}`.toLowerCase() === 'others' ? '' : e.target.value,
                      };
                    }
                    return _applicant;
                  }) as ContactDetailsProps[],
                });
              }}
              disabled={dataMasterLoading}
              loading={dataMasterLoading}
            />
          </Grid>

          {values.applicants.map((applicant, idx: number) => {
            if (`${applicant.phonePersonRelationType ?? ''}`.toLowerCase() === 'others' && idx === index) {
              return (
                <Grid item xs={12} lg={6} key={idx}>
                  <MFTextField
                    name={`applicants.${index}.phonePersonRelation`}
                    label="Please Specify Relationship*"
                    placeholder={`Enter Relationship`}
                    disabled={dataMasterLoading}
                  />
                </Grid>
              );
            }
          })}

          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.alternateNumber`}
              label="Alternate Number"
              placeholder="Enter Alternate Number"
              onKeyDown={(e) => {
                preventSpecialCharacters(e);
              }}
              startAdornment={
                <CountryCodesDropDown
                  ElementWidth={mobileElementWidth && mobileElementWidth}
                  name={`applicants.${index}.alternateNumberCountryNameAndCode`}
                  value={values.applicants[index].alternateNumberCountryNameAndCode}
                />
              }
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.whatsappNumber`}
              label="Whatsapp Number"
              placeholder="Enter Whatsapp Number"
              onKeyDown={(e) => {
                preventSpecialCharacters(e);
              }}
              startAdornment={
                <CountryCodesDropDown
                  ElementWidth={mobileElementWidth && mobileElementWidth}
                  name={`applicants.${index}.whatsappNumberCountryNameAndCode`}
                  value={values.applicants[index].whatsappNumberCountryNameAndCode}
                />
              }
            />
          </Grid>

          {/* {applicant.kraMobileNumber && (
            <Grid item xs={12} lg={6}>
              <MFTextField
                name={`applicants.${index}.kraMobileNumber`}
                label={`KRA Mobile Number`}
                placeholder="Enter KRA Mobile Number"
                disabled={true}
              />
            </Grid>
          )} */}
          {/* <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.phoneNumberoffice`}
              label="Phone (Office)"
              placeholder="Enter Phone (Office)"
              onChange={handleChange}
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            // startAdornment={
            //   <InputAdornment position="start">
            //     <CardMedia component="img" alt="Phone Icon" src="/images/phone.svg" />
            //   </InputAdornment>
            // }
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.phoneNumberResidence`}
              label="Phone (Residential)"
              placeholder="Enter Phone (Residential)"
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            // startAdornment={
            //   <InputAdornment position="start">
            //     <CardMedia component="img" alt="Phone Icon" src="/images/phone.svg" />
            //   </InputAdornment>
            // }
            />
          </Grid> */}
          {/* {applicant.address.nationality?.toLowerCase() !== 'indian' && (
            <React.Fragment>
              <SubHeading>Overseas Address of {getApplicantName(index + 1)} Applicant</SubHeading>
              <Address
                addressType={'overseas'}
                index={index}
                nationalitiesMdmsResponse={mdmsCountriesList}
                dataMasters={dataMasters}
              />
            </React.Fragment>
          )} */}
          {
            checkForCorrespondenceAddress(
              applicant.address.nationality,
              applicant.address.status || '',
              currencyCode
            ) ? (
              <>
                <Grid item xs={12}>
                  <SubHeading>
                    Correspondence Address of {getApplicantName(index + 1)} Applicant
                  </SubHeading>
                </Grid>
                <Address
                  addressType={'correspondence'}
                  index={index}
                  // nationalitiesMdmsResponse={mdmsCountriesList}
                  key={values.applicants.length}
                  // fetchedFromKRACheck={applicant.address.correspondence?.fetchedFromKRA || null}
                  fetchedFromKRACheck={isRMFieldDisabled || false}
                  dataMasters={dataMasters}
                  dataMasterLoading={dataMasterLoading}
                />
              </>
            ) : (
              <React.Fragment>
                <Grid item xs={12}>
                  <SubHeading>Overseas Address of {getApplicantName(index + 1)} Applicant</SubHeading>
                </Grid>
                <Address
                  addressType={'overseas'}
                  index={index}
                  // nationalitiesMdmsResponse={mdmsCountriesList}
                  // fetchedFromKRACheck={applicant.address.overseas?.fetchedFromKRA || null}
                  fetchedFromKRACheck={isRMFieldDisabled || false}
                  dataMasters={dataMasters}
                  dataMasterLoading={dataMasterLoading}
                />
              </React.Fragment>
            )}
          <Grid item xs={12}>
            <SubHeading>Permanent Address of {getApplicantName(index + 1)} Applicant</SubHeading>
          </Grid>
          {`${applicant.address.status ?? ''}`.toLowerCase() === 'individual' && applicant.address.nationality &&
            // !applicant.address.permanent?.fetchedFromKRA &&
            // !applicant.address.correspondence?.fetchedFromKRA &&
            // !applicant.address.overseas?.fetchedFromKRA &&
            (
              <Grid item container xs={12} alignItems="center">
                <MFCheckbox
                  onChange={({ target: { checked } }) =>
                    setValues({
                      ...values,
                      applicants: values.applicants.map((_applicant, _index) => {
                        if (_index === index) {
                          return {
                            ..._applicant,
                            address: checkForCorrespondenceAddress(
                              _applicant.address.nationality,
                              _applicant.address.status || '',
                              currencyCode
                            )
                              ? {
                                ..._applicant.address,
                                correspondence: {
                                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                  ..._applicant.address.correspondence!,
                                  permanentAddressSameAsCorresponding: checked,
                                },
                                ...(!checked && { permanent: getAddressFields('permanent') }),
                              }
                              : {
                                ..._applicant.address,
                                overseas: {
                                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                  ..._applicant.address.overseas!,
                                  permanentAddressSameAsCorresponding: checked,
                                },
                                ...(!checked && { permanent: getAddressFields('permanent') }),
                              },
                          };
                        }
                        return _applicant;
                      }),
                    })
                  }
                  name={`applicants.${index}.address.${checkForCorrespondenceAddress(
                    applicant.address.nationality,
                    applicant.address.status || '',
                    currencyCode
                  )
                    ? 'correspondence'
                    : 'overseas'
                    }.permanentAddressSameAsCorresponding`}
                  label={
                    checkForCorrespondenceAddress(
                      applicant.address.nationality,
                      applicant.address.status || '',
                      currencyCode
                    )
                      ? 'Permanent address same as correspondence address.'
                      : 'Permanent address same as overseas address.'
                  }
                  // sx={{ ml: '40px' }}
                  // disabled={isDiyInvestorOnboarding ? false : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
                  disabled={isRMFieldDisabled || `${values.applicants[index]?.address?.correspondence?.country ?? ''}`.toLowerCase() !== 'india' || false}
                />
              </Grid>
            )}
          {(checkForCorrespondenceAddress(
            applicant.address.nationality,
            applicant.address.status || '',
            currencyCode
          )
            ? !values.applicants[index]?.address?.correspondence
              ?.permanentAddressSameAsCorresponding
            : !values.applicants[index]?.address?.overseas
              ?.permanentAddressSameAsCorresponding) && (
              <>
                <Address
                  addressType={'permanent'}
                  index={index}
                  // nationalitiesMdmsResponse={mdmsCountriesList}
                  // fetchedFromKRACheck={applicant.address.permanent?.fetchedFromKRA || null}
                  fetchedFromKRACheck={isRMFieldDisabled || false}
                  dataMasters={dataMasters}
                  dataMasterLoading={dataMasterLoading}
                />
              </>
            )}
        </React.Fragment>
      ))
      }
    </React.Fragment >
  );
};

export default function ContactDetails(): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { currencyCode = "INR" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [contactDetails, setContactDetails] = useState(initialValues);
  // const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { path: currentPath } = useRouteMatch();
  const [isRMFieldDisabled, setRMFieldDisabled] = useState<boolean>(false);

  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application");
  const [isRekyc, setIsRekyc] = useState<boolean>(false);
  // const isRMFieldDisabled = ![USER_ROLES.INVESTOR].includes(role);
  const [dataMasters, setDataMasters] = useState<DataMaster>({} as DataMaster);
  const [dataMasterLoading, setDataMasterLoading] = useState<boolean>(false);
  const [mobMaster, setMobMaster] = useState<string[]>([]);
  const [emailMaster, setEmailMaster] = useState<string[]>([]);
  const [isShowErrPopup, setShowErrPopup] = useState<boolean>(false);

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
  //       setDataMasters(res?.data ?? {});
  //       setMobMaster((res?.data?.MOB_BELONGS_TO || []).map((item) => item?.description));
  //       setEmailMaster((res?.data?.MAIL_ID_BELONGS_TO || []).map((item) => item?.description));
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);

  const handleSubmit = async (values: Values) => {
    setShowErrPopup(false);
    try {
      const {
        applicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { saveType = '' } = values;
      const updatePayload = applicants
        .map((applicant, index: number) => {
          const {
            address: updatedAddresses = {},
            emailPersonRelationType,
            phonePersonRelationType,
            ...rest
          } = values.applicants[index] || {};
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { nationality, status, ...addressProps } = updatedAddresses;
          return {
            ...applicant,
            ...rest,
            email: removeSingleQuote(rest.email),
            countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
            addresses:
              !checkForCorrespondenceAddress(applicant.nationality, status, currencyCode) &&
                applicant.addresses?.map((address) => address.address_type).includes('correspondence')
                ? [
                  ..._updatedAddresses(updatedAddresses, applicant),
                  {
                    ...getAddressData('correspondence', applicant.addresses),
                    isActive: false,
                    address_type: 'correspondence',
                  },
                ]
                : checkForCorrespondenceAddress(applicant.nationality, status, currencyCode) &&
                  applicant.addresses?.map((address) => address.address_type).includes('overseas')
                  ? [
                    ..._updatedAddresses(updatedAddresses, applicant),
                    {
                      ...getAddressData('overseas', applicant.addresses),
                      isActive: false,
                      address_type: 'overseas',
                    },
                  ]
                  : _updatedAddresses(updatedAddresses, applicant),
            emailPersonRelation: emailPersonRelationType ? getEmailPhonePersonRelationType(mobMaster, emailPersonRelationType)
              ? emailPersonRelationType
              : removeSingleQuote(rest.emailPersonRelation)
              : '',
            phonePersonRelation: phonePersonRelationType ? getEmailPhonePersonRelationType(emailMaster, phonePersonRelationType)
              ? phonePersonRelationType
              : removeSingleQuote(rest.phonePersonRelation)
              : '',
            alternateNumberCountryCode: rest.alternateNumberCountryNameAndCode?.split(':')[1].trim(),
            whatsappNumberCountryCode: rest.whatsappNumberCountryNameAndCode?.split(':')[1].trim(),
          };
        })
        .map((_applicant) => {
          return {
            ..._applicant,
            addresses: _applicant.addresses.map((address) => {
              return {
                ...address,
                address1: removeSingleQuote(address.address1),
                address2: removeSingleQuote(address.address2),
                address3: removeSingleQuote(address.address3),
                city: removeSingleQuote(address.city),
                state: removeSingleQuote(address.state),
                otherCity:
                  (`${address.address_type ?? ''}`.toLowerCase() === 'overseas' || `${address.city ?? ''}`.toLowerCase() === 'others')
                    ? removeSingleQuote(address.otherCity)
                    : '',
                otherState:
                  (`${address.address_type ?? ''}`.toLowerCase() === 'overseas' || `${address.state ?? ''}`.toLowerCase() === 'others')
                    ? removeSingleQuote(address.otherState)
                    : '',
              };
            }),
          };
        });
      const checkApplication = applicationComparison(
        {
          ...application,
          applicants: application?.applicants
            ?.map((applicant) => {
              return {
                ...applicant,
                addresses: applicant.addresses?.sort(
                  (address1, address2) => Number(address1.id) - Number(address2.id)
                ),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        },
        {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...application!,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          applicants: updatePayload
            .map((applicant) => {
              return {
                ...applicant,
                addresses: applicant?.addresses?.sort(
                  (address1, address2) => Number(address1.id) - Number(address2.id)
                ),
              };
            })
            .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
          currentStep: !!currentStep && currentStep > 2 ? currentStep : isRekyc ? 4 : Number(currentStep) + 2,
        }
      );
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        const response = await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              applicants: updatePayload!,
              // status:
              //   !hasPOA &&
              //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
              //     status !== 'draft' &&
              //     applyRoleBasedStatus(role)
              //     ? 'sent_to_amc_approver'
              //     : status,
              status: sendRoleBasedStatus(role, status as string),
              currentStep: !!currentStep && currentStep > 2 ? currentStep : isRekyc ? 4 : Number(currentStep) + 2,
            },
            applicationId: id,
            ...(isSaveLater && {
              toastMessage: '',
            }),
          })
        );

        if (Object.keys(response ?? {}).length) {
          !isSaveLater
            ? history.push(isRekyc ? 'document-details' : 'additional-KYC-details', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
        }

      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push(isRekyc ? 'document-details' : 'additional-KYC-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
    finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const nationalitiesMdmsMasters = (await dispatch(
  //         getNationalityList()
  //       )) as unknown as nationaliyType;
  //       setMdmsCountriesList(nationalitiesMdmsMasters.countries);
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);

  useEffect(() => {
    const { applicants: exisitingApplicants = [], hasPOA = false } = application || {};
    (async function () {
      try {
        // const nationalitiesMdmsMasters = (await dispatch(
        //   getNationalityList()
        // )) as unknown as nationaliyType;
        // setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setDataMasterLoading(true);
        let mobMaster = [] as string[], emailMaster = [] as string[];
        const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
        if (res?.data) {
          setDataMasterLoading(false);
          setDataMasters(res?.data ?? {});
          mobMaster = (res?.data?.MOB_BELONGS_TO || [])?.map((item) => item?.description);
          emailMaster = (res?.data?.MAIL_ID_BELONGS_TO || [])?.map((item) => item?.description);
          setMobMaster(mobMaster);
          setEmailMaster(emailMaster);
        }

        setContactDetails({
          ...contactDetails,
          hasPOA,
          applicants:
            exisitingApplicants?.length === 0
              ? exisitingApplicants.map((applicant) => {
                const {
                  nationality = '',
                  status = '',
                  phoneNumberoffice = '',
                  phoneNumberResidence = '',
                  email = '',
                  mobile = '',
                  countryNameAndCode = 'India: +91',
                  countryCode = '+91',
                  kraMobileNumber = '',
                  emailPersonRelation = '',
                  emailPersonRelationType = '',
                  phonePersonRelation = '',
                  phonePersonRelationType = '',
                  whatsappNumber = '',
                  whatsappNumberCountryNameAndCode = 'India: +91',
                  whatsappNumberCountryCode = '+91',
                  alternateNumberCountryNameAndCode = 'India: +91',
                  alternateNumberCountryCode = '+91',
                  alternateNumber = '',
                } = applicant;
                const defaultPayload = {
                  nationality,
                  status,
                  phoneNumberoffice,
                  phoneNumberResidence,
                  email,
                  mobile,
                  whatsappNumber,
                  whatsappNumberCountryNameAndCode: applicant.whatsappNumberCountryNameAndCode
                    ? applicant.whatsappNumberCountryNameAndCode
                    : 'India: +91',
                  whatsappNumberCountryCode: applicant.whatsappNumberCountryCode
                    ? applicant.whatsappNumberCountryCode
                    : '+91',
                  alternateNumberCountryNameAndCode: alternateNumberCountryNameAndCode
                    ? alternateNumberCountryNameAndCode
                    : 'India: +91',
                  alternateNumberCountryCode: applicant.alternateNumberCountryCode
                    ? applicant.alternateNumberCountryCode
                    : '+91',
                  alternateNumber,
                  countryNameAndCode: applicant.countryNameAndCode
                    ? applicant.countryNameAndCode
                    : 'India: +91',
                  countryCode: applicant.countryCode ? applicant.countryCode : '+91',
                  address: {
                    nationality: null,
                    status: null,
                    permanent: getAddressFields('permanent'),
                  },
                  kraMobileNumber,
                  emailPersonRelationType: emailPersonRelation
                    ? getEmailPhonePersonRelationType(emailMaster, emailPersonRelation)
                      ? emailPersonRelation
                      : 'Others'
                    : 'Self',
                  emailPersonRelation: getEmailPhonePersonRelationType(emailMaster, emailPersonRelation)
                    ? ''
                    : emailPersonRelation,
                  phonePersonRelationType: phonePersonRelation
                    ? getEmailPhonePersonRelationType(mobMaster, phonePersonRelation)
                      ? phonePersonRelation
                      : 'Others'
                    : 'Self',
                  phonePersonRelation: getEmailPhonePersonRelationType(mobMaster, phonePersonRelation)
                    ? ''
                    : phonePersonRelation,
                };
                if (
                  (currencyCode?.toLowerCase() === "inr" ? ['indian', null] : ['others', null]).includes(applicant.nationality?.toLowerCase() || '') &&
                  applicantStatusMasters[applicant.status || ''] ===
                  applicantStatusMasters.Individual
                ) {
                  return {
                    ...defaultPayload,
                    address: {
                      ...defaultPayload.address,
                      correspondence: getAddressFields('correspondence'),
                    },
                  };
                }
                return {
                  ...defaultPayload,
                  address: {
                    ...defaultPayload.address,
                    overseasAddress: getAddressFields('overseas'),
                  },
                };
              })
              : exisitingApplicants?.map((applicant) => {
                const {
                  phoneNumberoffice = '',
                  phoneNumberResidence = '',
                  email = '',
                  mobile = '',
                  countryNameAndCode = 'India: +91',
                  countryCode = '+91',
                  kraMobileNumber = '',
                  emailPersonRelation = '',
                  emailPersonRelationType = '',
                  phonePersonRelation = '',
                  phonePersonRelationType = '',
                  whatsappNumber = '',
                  whatsappNumberCountryNameAndCode = 'India: +91',
                  whatsappNumberCountryCode = '+91',
                  alternateNumber = '',
                  alternateNumberCountryNameAndCode = 'India: +91',
                  alternateNumberCountryCode = '+91',

                } = applicant;
                const correspondence = getAddressData('correspondence', applicant.addresses);
                const permanent = getAddressData('permanent', applicant.addresses);
                const overseas = getAddressData('overseas', applicant.addresses);
                const defaultPayload = {
                  phoneNumberoffice,
                  phoneNumberResidence,
                  email,
                  mobile,
                  countryNameAndCode: applicant.countryNameAndCode
                    ? applicant.countryNameAndCode
                    : 'India: +91',
                  countryCode: applicant.countryCode ? applicant.countryCode : '+91',
                  address: {
                    nationality: applicant.nationality,
                    status: applicant.status,
                  },
                  kraMobileNumber,
                  alternateNumber,
                  alternateNumberCountryNameAndCode: alternateNumberCountryNameAndCode
                    ? alternateNumberCountryNameAndCode
                    : 'India: +91',
                  alternateNumberCountryCode: applicant.alternateNumberCountryCode
                    ? applicant.alternateNumberCountryCode
                    : '+91',
                  whatsappNumber,
                  whatsappNumberCountryNameAndCode: applicant.whatsappNumberCountryNameAndCode
                    ? applicant.whatsappNumberCountryNameAndCode
                    : 'India: +91',
                  whatsappNumberCountryCode: applicant.whatsappNumberCountryCode
                    ? applicant.whatsappNumberCountryCode
                    : '+91',
                  emailPersonRelationType: emailPersonRelation
                    ? getEmailPhonePersonRelationType(mobMaster, emailPersonRelation)
                      ? emailPersonRelation
                      : 'Others'
                    : 'Self',
                  emailPersonRelation: getEmailPhonePersonRelationType(mobMaster, emailPersonRelation)
                    ? ''
                    : emailPersonRelation,
                  phonePersonRelationType: phonePersonRelation
                    ? getEmailPhonePersonRelationType(mobMaster, phonePersonRelation)
                      ? phonePersonRelation
                      : 'Others'
                    : 'Self',
                  phonePersonRelation: getEmailPhonePersonRelationType(mobMaster, phonePersonRelation)
                    ? ''
                    : phonePersonRelation,
                };
                const permanentAddressPayload =
                  (currencyCode?.toLowerCase() === "inr" ? ['indian', null] : ['others', null]).includes(applicant.nationality?.toLowerCase() || '') &&
                    applicantStatusMasters[applicant.status || ''] ===
                    applicantStatusMasters.Individual
                    ? correspondence.permanentAddressSameAsCorresponding
                      ? defaultPayload
                      : {
                        ...defaultPayload,
                        address: {
                          ...defaultPayload.address,
                          permanent: {
                            ...permanent,
                            country: permanent.country
                              ? permanent.country
                              : 'India',
                          },
                        },
                      }
                    : overseas.permanentAddressSameAsCorresponding
                      ? defaultPayload
                      : {
                        ...defaultPayload,
                        address: {
                          ...defaultPayload.address,
                          permanent: {
                            ...permanent,
                            country: permanent.country
                              ? permanent.country
                              : 'India',
                          },
                        },
                      };
                return (currencyCode?.toLowerCase() === "inr" ? ['indian', null] : ['others', null]).includes(applicant.nationality?.toLowerCase() || '') &&
                  applicantStatusMasters[applicant.status || ''] ===
                  applicantStatusMasters.Individual
                  ? {
                    ...permanentAddressPayload,
                    address: {
                      ...permanentAddressPayload.address,
                      correspondence: {
                        ...correspondence,
                        country: correspondence.country
                          ? correspondence.country
                          : 'India',
                      },
                    },
                  }
                  : {
                    ...permanentAddressPayload,
                    address: {
                      ...permanentAddressPayload.address,
                      overseas: {
                        ...overseas,
                        country: overseas.country ? overseas.country : '',
                        countryNameAndCode: overseas.countryNameAndCode ? overseas.countryNameAndCode : 'India: +91',
                      },
                    },
                  };
              }),
          // countryDropdown: nationalitiesMdmsMasters.countries?.map((list) => list.name),
          countryDropdown: res?.data?.COUNTRY?.map((list: any) => list.description || '') || [],
        });
        setRMFieldDisabled(!(([USER_ROLES.RM].includes(role) || [USER_ROLES.INVESTOR].includes(role)) && exisitingApplicants?.[0]?.kycMethod === 'osv') || (([USER_ROLES.INVESTOR].includes(role) || [USER_ROLES.INVESTOR].includes(role)) && exisitingApplicants?.[0]?.kycMethod !== 'osv'));
        setIsRekyc(`${application?.rekycStatus ?? ''}`.toLowerCase() == 'pending');
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  return (
    <Formik
      initialValues={contactDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, contactDetailsSchema(currencyCode, isRMFieldDisabled), true, values);
        } catch (e) {
          if (isShowErrPopup) {
            setShowErrPopup(false);
            dispatch(showError(`Please fill all required fields`));
          }
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, handleChange, setFieldValue }) => (
        <Grid
          container
          columnSpacing={3}
          rowSpacing={0.5}
          // rowSpacing={1}
          // columnSpacing={5}
          // sx={{
          //   width: '100%',
          //   ml: 0,
          //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          // }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <ApplicantDetails
            values={values}
            handleChange={handleChange}
            setValues={setValues}
            // mdmsCountriesList={mdmsCountriesList}
            application={application}
            isRMFieldDisabled={isRMFieldDisabled}
            dataMasters={dataMasters}
            dataMasterLoading={dataMasterLoading}
            isRekyc={isRekyc}
          />
          <Grid item xs={12} my={1} />
          {!!application?.applicants.length && (
            <ProceedSaveLater
              saveLater={() => {
                setShowErrPopup(true);
                setFieldValue('saveType', 'save for later');
              }}
              saveAndProceed={() => {
                setShowErrPopup(true);
                setFieldValue('saveType', 'save and proceed');
              }}
              loader={loading}
              clickedButton={values.saveType}
              saveButtonText="Continue"
              showEndIcon={false}
            />
          )}
        </Grid>
      )}
    </Formik>
  );
}
